import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { TimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import { useCurrency } from 'src/hooks/useCurrency';
import {
  MonthYearDateFormatter,
  currencyValueTickFormatter,
} from 'src/utils/TickFormatters';
import { MEDIA_INVESTMENT_DEF } from 'src/utils/metricDefinitions';
import { useLTDataContext } from '../../contexts/LTDataContext';

const title = 'Investment';

export const InvestmentOTBox: React.FC = () => {
  const { investments, isError, isLoading } = useLTDataContext();
  const { code } = useCurrency();
  const investmentTickFormatter = currencyValueTickFormatter(code);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return investments.monthly.map((x) => ({
      utcEpoch: x.utcEpoch,
      value: x.totalInvestment,
    }));
  }, [investments]);

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel={title}
      data={data}
      xAxisFormatter={MonthYearDateFormatter}
      yAxisFormatter={investmentTickFormatter}
      isError={isError}
      isLoading={isLoading}
      infoText={MEDIA_INVESTMENT_DEF}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={investmentTickFormatter}
          dateFormatter={MonthYearDateFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
